import {
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
  SearchInput,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useExamLocationRequestListSearchParams } from '../../hooks';
import ExamLocationRequestListFilters from '../exam-location-request-list-filter-form/exam-location-request-list-filter-form';

export default function ExamLocationRequestListFilterSection() {
  const [, { changeLocationName }] = useExamLocationRequestListSearchParams();

  const [isExpand, { toggle }] = useDisclosure();

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Flex sx={{ maxWidth: 300, width: '100%' }}>
          <SearchInput
            onChange={(value) => changeLocationName(value)}
            placeholder='ค้นหาชื่อสถานที่/หน่วยงาน...'
          />
        </Flex>
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <ExamLocationRequestListFilters />
      </Collapse>
    </>
  );
}
